import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import { isBoolean } from "lodash";
import { TenantRegistrationDto } from "../../../common/data/service-proxies";
import { useHistory } from "react-router-dom";

interface Props {
  label: string;
  icon: JSX.Element;
  record?: TenantRegistrationDto;
  resource?: string;
  onClick?: (event: React.MouseEvent) => void;
  hidden?: boolean | ((record: TenantRegistrationDto) => boolean);
}

export const ViewEldUsageByEventsMenuItem = ({
  record,
  hidden,
  label,
  icon,
  onClick,
  ...rest
}: Props) => {
  const history = useHistory();

  if (!record?.id) {
    return null;
  }

  if (isBoolean(hidden)) {
    if (hidden) {
      return null;
    }
  } else {
    if (hidden && hidden(record)) {
      return null;
    }
  }

  return (
    <MenuItem
      {...rest}
      className="actions-menu-item"
      onClick={(e) => {
        history.push(
          `/master-tenant-registrations/${record.id}/eld-usage-by-events`
        );
        if (typeof onClick === "function") {
          onClick(e);
        }
      }}
    >
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText>{label}</ListItemText>
    </MenuItem>
  );
};
